import { render, staticRenderFns } from "./dialog-detailfile.vue?vue&type=template&id=475e37eb&"
import script from "./dialog-detailfile.vue?vue&type=script&lang=js&"
export * from "./dialog-detailfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports